/* Meridian Leads theme JS */
(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  var burger = document.getElementById('BurgerBtn');
  var drawer = document.getElementById('MobileDrawer');
  if (burger && drawer) {
    burger.addEventListener('click', function () {
      var open = burger.getAttribute('aria-expanded') === 'true';
      burger.setAttribute('aria-expanded', String(!open));
      drawer.hidden = open;
    });
  }

  /* ---------- Count-up stats ---------- */
  var counters = document.querySelectorAll('[data-countup]');
  if (counters.length && 'IntersectionObserver' in window) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var target = parseInt(el.dataset.target, 10) || 0;
        var suffix = el.dataset.suffix || '';
        if (reduceMotion) { el.textContent = target + suffix; return; }
        var duration = 1600;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    counters.forEach(function (el) { io.observe(el); });
  } else {
    counters.forEach(function (el) {
      el.textContent = (el.dataset.target || '0') + (el.dataset.suffix || '');
    });
  }

  /* ---------- Testimonial marquee: duplicate tracks for seamless loop ---------- */
  document.querySelectorAll('.testimonials__track').forEach(function (track) {
    track.innerHTML += track.innerHTML;
  });

  /* ---------- Promo popup ---------- */
  var popup = document.getElementById('PromoPopup');
  if (popup) {
      var delay = (parseInt(popup.dataset.delay, 10) || 0) * 1000;
      setTimeout(function () {
        popup.hidden = false;
        document.body.style.overflow = 'hidden';
        var closeBtn = popup.querySelector('.popup__close');
        if (closeBtn) closeBtn.focus();
      }, delay);

      function closePopup() {
        popup.hidden = true;
        document.body.style.overflow = '';
        
      }
      popup.querySelectorAll('[data-popup-close]').forEach(function (el) {
        el.addEventListener('click', closePopup);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !popup.hidden) closePopup();
      });
    
  }
})();

/* ---------- Contact CTA: preselect Interest dropdown on jump ---------- */
(function () {
  document.querySelectorAll('.info-duo__btn[data-interest]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var val = btn.getAttribute('data-interest');
      var sel = document.getElementById('ContactInterest');
      if (sel) {
        var opts = sel.options;
        for (var i = 0; i < opts.length; i++) {
          if (opts[i].value === val) { sel.selectedIndex = i; break; }
        }
      }
    });
  });
})();
